// SWAPA Dark theme — 交互脚本
(function () {
  'use strict';

  // 移动端菜单
  var header = document.getElementById('SiteHeader');
  var toggle = document.querySelector('.header-menu-toggle');

  // 首屏为全出血 snap-section 时，main 顶到视口顶部（导航浮在其上层）
  // （:has() 的 JS 兜底，老浏览器走这条）
  var main = document.getElementById('MainContent');
  if (main) {
    var firstEl = main.firstElementChild;
    while (firstEl && firstEl.nodeType !== 1) firstEl = firstEl.nextElementSibling;
    if (firstEl && firstEl.classList.contains('snap-section')) main.classList.add('main-full-bleed');
  }

  if (header && toggle) {
    toggle.addEventListener('click', function () {
      var open = header.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // 固定导航实测高度 → 写入 --nav-h（各整屏版块靠它留出顶部避让，避免内容被导航盖住）
  // 量 .header-inner 而不是 header 本身：移动端抽屉展开时 header 会变高，不能污染这个值
  if (header) {
    var navBar = header.querySelector('.header-inner') || header;
    var setNavH = function () {
      var h = Math.round(navBar.getBoundingClientRect().height);
      if (h > 0) document.documentElement.style.setProperty('--nav-h', h + 'px');
    };
    setNavH();
    window.addEventListener('resize', setNavH);
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(setNavH); }
  }

  // 导航滚出首屏后加深色底（首屏内保持透明浮在图上）
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 60);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // 语言切换
  document.querySelectorAll('.header-locale select[name="locale_code"]').forEach(function (sel) {
    sel.addEventListener('change', function () { sel.closest('form').submit(); });
  });

  // 视频：点击才下载 + 弱网自动降级 720p + 缓冲提示
  function pickVideoUrl(btn) {
    var hd = btn.getAttribute('data-video-url') || '';
    var lite = btn.getAttribute('data-video-url-lite') || '';
    if (!lite) return hd;
    var c = navigator.connection || navigator.webkitConnection || navigator.mozConnection;
    if (c && (c.saveData || /^(slow-)?2g$|^3g$/.test(c.effectiveType || ''))) return lite;
    if (window.matchMedia && window.matchMedia('(max-width: 640px)').matches && /^(slow-)?2g$|^3g$|^4g$/.test(c && c.effectiveType || '')) return lite;
    return hd;
  }

  document.querySelectorAll('[data-video-section]').forEach(function (wrap) {
    var btn = wrap.querySelector('.play-button');
    var loading = wrap.querySelector('[data-video-loading]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var url = pickVideoUrl(btn);
      if (!url) return;
      if (loading) loading.hidden = false;

      var done = function () { if (loading) loading.hidden = true; };

      if (url.indexOf('youtube') > -1 || url.indexOf('youtu.be') > -1) {
        var embed = document.createElement('iframe');
        embed.className = 'media-hero__embed';
        embed.setAttribute('allow', 'autoplay; fullscreen; encrypted-media');
        embed.setAttribute('allowfullscreen', '');
        var id = url.match(/(?:v=|youtu\.be\/)([\w-]{6,})/);
        embed.src = 'https://www.youtube-nocookie.com/embed/' + (id ? id[1] : '') + '?autoplay=1&rel=0';
        embed.addEventListener('load', done);
        wrap.appendChild(embed);
        btn.remove();
        return;
      }

      var video = document.createElement('video');
      video.className = 'media-hero__embed';
      video.src = url;
      video.preload = 'auto';
      video.autoplay = true;
      video.controls = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.addEventListener('canplay', done, { once: true });
      video.addEventListener('playing', done, { once: true });
      video.addEventListener('error', done, { once: true });
      wrap.appendChild(video);
      btn.remove();
    });
  });

  // 幻灯片式滚动（桌面端，首页与 ZIP 等含多个整屏版块的页面）。停靠点 = 各整屏版块顶部 + 首页亮点卡片区子停靠点 + 页脚终点
  var isDesktop = window.matchMedia('(min-width: 992px)').matches;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var snapSections = document.querySelectorAll('.snap-section');
  if (snapSections.length > 1 && isDesktop && !reduceMotion) {
    var stops = [];
    var animating = false;

    function computeStops() {
      var list = [];
      document.querySelectorAll('.snap-section').forEach(function (s) {
        list.push({ y: Math.max(0, s.offsetTop), el: s, sub: false });
      });
      var hl = document.querySelector('.highlights');
      if (hl) {
        var cards = hl.querySelectorAll('.card-img');
        if (cards.length > 2) {
          var hlTop = Math.max(0, hl.offsetTop);
          var lastY = hl.offsetTop + hl.offsetHeight - window.innerHeight; // 末排底对齐位置
          list.push({ y: hlTop, el: hl, sub: true });
          var pitch = cards[2].offsetTop - cards[0].offsetTop; // 一排卡 + 间距
          // 逐排停靠点；离终点不足半排的跳过，避免"只挪一小截"的多余停靠
          for (var off = pitch; off < lastY - hlTop - pitch * 0.5; off += pitch) {
            list.push({ y: hlTop + off, el: hl, sub: true });
          }
          if (lastY > hlTop + 10) list.push({ y: lastY, el: hl, sub: true });
        }
      }
      var footer = document.querySelector('.site-footer');
      if (footer) {
        var endY = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
        if (endY > 0) list.push({ y: endY, el: footer, sub: true }); // 最后一滚直接滑到底，页脚完整展示
      }
      list.sort(function (a, b) { return a.y - b.y; });
      // 去掉过近的重复点
      stops = list.filter(function (v, i) { return i === 0 || v.y - list[i - 1].y > 40; });
    }
    computeStops();
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(computeStops, 200);
    });

    window.addEventListener('wheel', function (e) {
      if (!stops.length) return;
      if (animating) { e.preventDefault(); return; } // 动画进行中吞掉滚轮，防止滑过头偏离停靠点
      var y = window.scrollY;
      var at = -1;
      for (var i = 0; i < stops.length; i++) {
        if (Math.abs(y - stops[i].y) < 20) { at = i; break; }
      }
      var target = null;
      if (at !== -1) {
        var st = stops[at];
        // 超高版块（内容比一屏高）：看完剩余内容前不接管
        if (!st.sub && st.el.offsetHeight > window.innerHeight + 20) {
          if (e.deltaY > 0 && st.el.offsetTop + st.el.offsetHeight - y - window.innerHeight > 20) return;
          if (e.deltaY < 0 && y - st.el.offsetTop > 20) return;
        }
        target = e.deltaY > 0 ? stops[at + 1] : stops[at - 1];
      } else {
        // 恢复逻辑：不在停靠点上。若身处超高的整屏版块内部（卡片区除外），走自然滚动
        var insideTall = false;
        document.querySelectorAll('.snap-section').forEach(function (s) {
          if (s.offsetHeight <= window.innerHeight + 20) return;
          if (y > s.offsetTop + 12 && y < s.offsetTop + s.offsetHeight - window.innerHeight - 12) insideTall = true;
        });
        if (insideTall) return;
        // 否则归位到滚动方向上的下一个停靠点
        if (e.deltaY > 0) {
          for (var j = 0; j < stops.length; j++) { if (stops[j].y > y + 12) { target = stops[j]; break; } }
        } else {
          for (var k = stops.length - 1; k >= 0; k--) { if (stops[k].y < y - 12) { target = stops[k]; break; } }
        }
      }
      if (!target) return;
      e.preventDefault();
      animating = true;
      window.scrollTo({ top: target.y, behavior: 'smooth' });
      setTimeout(function () { animating = false; }, 700);
    }, { passive: false });
  }

  // ZIP 图片组已改为静态并排展示，原横滑轮播交互脚本于 2026-10-20 移除

  // ZIP 颜色屏：点色卡 → 车漆"从左到右擦除"切换。
  // 两层互补裁剪：新色从左露出多少，旧色就同步从左消失多少（不重叠 → 无重影）
  // 动画结束只交换两层角色，绝不替换可见层的 src（避免解码抖动）
  document.querySelectorAll('[data-color-swatches]').forEach(function (wrap) {
    var section = wrap.closest('section');
    var nameEl = section.querySelector('[data-color-name]');
    var layers = section.querySelectorAll('.zip-colors__car');
    if (layers.length < 2) return;
    var front = layers[0];                 // 当前可见层
    var back = layers[1];                  // 隐藏层（下一张色）
    var swatches = wrap.querySelectorAll('.zip-swatch');
    var busy = false;
    var DUR = 700;

    function setClip(el, clip) {           // 无过渡地设置裁剪区（用于复位，避免反向回放）
      el.style.transition = 'none';
      el.style.clipPath = clip;
      void el.offsetWidth;
      el.style.transition = '';
    }
    setClip(front, 'inset(0 0 0 0)');
    setClip(back, 'inset(0 100% 0 0)');

    swatches.forEach(function (sw) {       // 预加载，wipe 过程不闪白
      var c = sw.getAttribute('data-swatch-car');
      if (c) { var pre = new Image(); pre.src = c; }
    });

    swatches.forEach(function (sw) {
      sw.addEventListener('click', function () {
        swatches.forEach(function (s) { s.classList.remove('is-active'); });
        sw.classList.add('is-active');
        var n = sw.getAttribute('data-swatch-name');
        if (nameEl && n) nameEl.textContent = n;

        var car = sw.getAttribute('data-swatch-car');
        if (!car || busy || front.getAttribute('src') === car) return;
        busy = true;
        var incoming = back, outgoing = front;

        var run = function () {
          setClip(incoming, 'inset(0 100% 0 0)');
          setClip(outgoing, 'inset(0 0 0 0)');
          void incoming.offsetWidth;
          // 互补推进：新色从左露出，旧色从左被裁走
          incoming.style.clipPath = 'inset(0 0 0 0)';
          outgoing.style.clipPath = 'inset(0 0 0 100%)';
          setTimeout(function () {
            front = incoming; back = outgoing;   // 只换角色，不动 src
            setClip(back, 'inset(0 100% 0 0)');  // 旧层收起待命
            busy = false;
          }, DUR + 40);
        };

        incoming.src = car;
        if (incoming.decode) {
          incoming.decode().then(run).catch(run);
        } else {
          incoming.onload = run; incoming.onerror = run;
        }
      });
    });
  });

  // 进场渐显：已统一由下方的整屏渐入机制（.rv / .zip-reveal + IntersectionObserver）处理，此处不再单独挂载
})();

// 渐入动效：整屏版块进入视口时依次揭示；离开后复位，再进入会重播（配合整页翻页节奏）
// .pg-fade 用于内容页（about/faq/contact/dealers），页面可能高于视口，故用极低阈值
(function () {
  var secs = document.querySelectorAll('.snap-section, .highlights');
  var pgs = document.querySelectorAll('.pg-fade');
  if (!secs.length && !pgs.length) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mark = function (list) { list.forEach(function (s) { s.classList.add('is-in'); }); };
  if (reduce || !('IntersectionObserver' in window)) {
    mark(secs); mark(pgs);   // 无动画、直接显示
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      en.target.classList.toggle('is-in', en.isIntersecting);
    });
  }, { threshold: 0.3 });
  secs.forEach(function (s) { io.observe(s); });

  var ioPg = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) en.target.classList.add('is-in');
    });
  }, { threshold: 0.04, rootMargin: '0px 0px -8% 0px' });
  pgs.forEach(function (s) { ioPg.observe(s); });
})();

// About 顶部轮播：淡入切换 + 圆点
(function () {
  document.querySelectorAll('[data-about-slideshow]').forEach(function (root) {
    var slides = root.querySelectorAll('.about-hero__slide');
    var dots = root.querySelectorAll('.about-hero__dot');
    if (slides.length < 2) return;
    var i = 0, timer = null;
    var interval = parseInt(root.getAttribute('data-interval') || '0', 10) * 1000;

    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    function play() {
      stop();
      if (interval > 0) timer = setInterval(function () { go(i + 1); }, interval);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    dots.forEach(function (d, k) {
      d.addEventListener('click', function () { go(k); play(); });
    });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);
    play();
  });
})();

// 画册翻页：左右箭头 + 缩略图 + 键盘方向键
(function () {
  document.querySelectorAll('[data-brochure]').forEach(function (root) {
    var pages = root.querySelectorAll('.brochure-page');
    var thumbs = root.querySelectorAll('.brochure-thumb');
    var cur = root.querySelector('.brochure-cur');
    var prev = root.querySelector('.brochure-nav--prev');
    var next = root.querySelector('.brochure-nav--next');
    if (pages.length < 1) return;
    var i = 0;

    function go(n) {
      i = (n + pages.length) % pages.length;
      pages.forEach(function (p, k) { p.classList.toggle('is-active', k === i); });
      thumbs.forEach(function (t, k) {
        t.classList.toggle('is-active', k === i);
        if (k === i && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      });
      if (cur) cur.textContent = String(i + 1);
      if (pages.length < 2) { if (prev) prev.hidden = true; if (next) next.hidden = true; }
    }

    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { go(i - 1); } else if (e.key === 'ArrowRight') { go(i + 1); }
    });
    go(0);
  });
})();

// 参数条数字滚动（count-up）：与参数条渐入并行起跳（不再等待），900ms easeOut 收尾 + 落定弹跳
(function () {
  var strips = document.querySelectorAll('.zip-dimensions__stats');
  if (!strips.length) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DUR = 900;             // 滚动时长 ms
  var DELAY = 120;           // 渐入起步后立刻跟上

  function animate(el) {
    var target = parseFloat(el.getAttribute('data-count-to')) || 0;
    el.classList.remove('is-landed');
    if (reduce) { el.textContent = target; return; }
    var t0 = null;
    function step(t) {
      if (!t0) t0 = t;
      var p = Math.min(1, (t - t0) / DUR);
      var eased = 1 - Math.pow(1 - p, 3);           // easeOutCubic：先快后慢
      el.textContent = Math.round(target * eased);
      if (p < 1) { el._raf = requestAnimationFrame(step); }
      else { el.classList.add('is-landed'); }        // 到达：轻微 scale 弹跳
    }
    if (el._raf) cancelAnimationFrame(el._raf);
    el._raf = requestAnimationFrame(step);
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var nums = en.target.querySelectorAll('[data-count-to]');
      if (en.isIntersecting) {
        clearTimeout(en.target._statT);
        en.target._statT = setTimeout(function () {
          nums.forEach(animate);
        }, DELAY);
      } else {
        clearTimeout(en.target._statT);
        nums.forEach(function (el) {
          if (el._raf) cancelAnimationFrame(el._raf);
          el.classList.remove('is-landed');
          el.textContent = '0';
        });
      }
    });
  }, { threshold: 0.2 });
  strips.forEach(function (s) { io.observe(s); });
})();

// 图片组轮换：点任意一张 → 该图换到大图位，原大图退回小图位（无需 lightbox）
(function () {
  'use strict';
  document.querySelectorAll('.zip-carousel__grid--feature').forEach(function (grid) {
    var cells = Array.prototype.slice.call(grid.children);
    if (cells.length !== 3) return;
    cells.forEach(function (cell) {
      var btn = cell.querySelector('.zip-zoom');
      if (!btn) return;
      btn.addEventListener('click', function () {
        if (cell.classList.contains('is-lead')) return;
        cells.forEach(function (c) { c.classList.remove('is-lead'); });
        cell.classList.add('is-lead');
      });
    });
  });
})();

// ---------- 滚动提示：停留 3 秒未滚动且未到底时浮现，一滚动立即隐藏 ----------
(function () {
  'use strict';
  var IDLE_MS = 2600;   // 停留 2.6 秒未滚动即提示
  var isIndex = document.body && document.body.classList.contains('template-index');

  // 兜底：若 layout 未渲染该节点（模板判断/缓存等任何原因），这里自己建一个
  var hint = document.getElementById('ScrollHint');
  if (!hint) {
    hint = document.createElement('div');
    hint.id = 'ScrollHint';
    hint.className = 'scroll-hint';
    hint.setAttribute('aria-hidden', 'true');
    hint.innerHTML = '<img src="" alt=""><span>Scroll Down</span>';
    var iconEl = hint.querySelector('img');
    if (iconEl && window.__SWAPA_SCROLL_ICON) iconEl.src = window.__SWAPA_SCROLL_ICON;
    document.body.appendChild(hint);
  }

  function scrollTop() {
    var se = document.scrollingElement || document.documentElement;
    return se.scrollTop || window.pageYOffset || 0;
  }
  function scrollable() {
    var se = document.scrollingElement || document.documentElement;
    var total = Math.max(se.scrollHeight, document.body ? document.body.scrollHeight : 0);
    var left = total - window.innerHeight - scrollTop();
    return left > 16;               // 距离底部不足 16px 视为到底／不可滚
  }
  // 首页首屏自带 Slide Down 指示，仅在滑过首屏后再提示，避免两个提示叠在一起
  function suppressed() {
    return isIndex && scrollTop() < window.innerHeight * 0.6;
  }

  var lastMove = Date.now();
  var shown = false;
  function set(on) {
    if (on === shown) return;
    shown = on;
    hint.classList.toggle('is-visible', on);
  }
  function hide() { set(false); }
  function tick() {
    var idle = Date.now() - lastMove >= IDLE_MS;
    set(idle && !suppressed() && scrollable());
  }
  function markMove() {
    lastMove = Date.now();
    if (shown) hide();
  }

  window.addEventListener('scroll', markMove, { passive: true });
  window.addEventListener('wheel', markMove, { passive: true });
  window.addEventListener('touchstart', markMove, { passive: true });
  window.addEventListener('touchmove', markMove, { passive: true });
  window.addEventListener('keydown', function (e) {
    if (['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', 'Home', 'End', ' '].indexOf(e.key) > -1) markMove();
  });
  window.addEventListener('resize', function () { lastMove = Date.now(); hide(); });
  setInterval(tick, 400);   // 轮询兜底：即使事件被其它脚本吞掉也能按时间规则显隐
  tick();
})();
